import * as React from 'react';
import { FileInput, useTranslate } from 'react-admin';
import { useForm } from 'react-final-form';
import { apiUrl, httpClient } from '../providers/data.provider';
import { Link } from '@material-ui/core';
import _get from 'lodash-es/get';

const PreviewFile = ({ record, source, label }: any) => {
	const translator = useTranslate();

	if (typeof (record) == 'string') {
		record = {
			[source]: record
		};
	}
	return <Link href={_get(record, source)}>{translator(label)}</Link>;
};

export const CustomFileInput = ({ record, source, label, ...props }: any) => {
	const form = useForm();

	const onFileChange = async (fileToUpload: any) => {
		if (fileToUpload) {
			const formData = new FormData();

			formData.append('fileToUpload', fileToUpload);

			const { json } = await httpClient(`${apiUrl}/files/upload`, {
				method: 'POST',

				body: formData
			});

			form.change(source, json.data);
		}
	};

	return <FileInput {...props} label={label} source={source}
	                  onChange={onFileChange}
	>
		<PreviewFile label={label} source="src"/>
	</FileInput>;
};
